module.exports = __webpack_public_path__ + "static/media/Noticias3.920e9ab8.svg";